import { Typography } from "@/components/Typography"
import { useNavigate } from "react-router-dom"
import arrowRight from "@/assets/images/icons/arrowRight.svg"
import { useAlertDialog } from "@/shared/context/AlertDialogContext"
import { getSession } from "@/shared/utils/sessionStore"
import { useAuth } from "@/shared/provider/AuthProvider"

interface Props {
  title: string
  link: string
  unView?: boolean
}

const MainTitle = ({ title, link, unView }: Props) => {
  // Hook
  const { showAlert, closeAlert } = useAlertDialog()
  const { userInfo } = useAuth()

  const navigate = useNavigate()

  const handleNavigate = () => {
    if (userInfo) {
      navigate(link)
    } else {
      showAlert({
        logo: false,
        title: "Would you like to log in?",
        actionText: "Log in",
        cancelText: "Cancel",
        onConfirm: () => navigate("/login"),
        onCancel: () => closeAlert(),
      })
    }
  }

  return (
    <div className="flex justify-between items-center py-4 mx-4 border-t border-Divider">
      <Typography variant="h6">{title}</Typography>
      {!unView && (
        <button onClick={handleNavigate} className="cursor-pointer">
          <Typography variant="caption" className="flex gap-1 items-center">
            View all
            <img src={arrowRight} alt="" />
          </Typography>
        </button>
      )}
    </div>
  )
}

export default MainTitle
